import { bool, object, string } from 'prop-types'
import { parseChartsData } from './chart-helpers'
import AnalyticsChart from './AnalyticsChart'
import { DateTime } from 'luxon'

const propTypes = {
  event: object.isRequired,
  today: bool,
  stringer: string
}

const DueTimesChart = ({ event, stringer, today = false }) => {
  const CHART_ID = 'due-time-count'

  const parseData = data => {
    const parsedData = parseChartsData(data)
    if (parsedData.length === 2) {
      parsedData.push([parsedData[1][0] + 1, 0])
    }
    return parsedData
  }

  const options = {
    colors: ['#64B0BA'],
    legend: {
      position: 'none'
    },
    hAxis: {
      ticks: [
        { v: 3, f: '3am' },
        { v: 6, f: '6am' },
        { v: 9, f: '9am' },
        { v: 12, f: '12pm' },
        { v: 15, f: '3pm' },
        { v: 18, f: '6pm' },
        { v: 21, f: '9pm' },
        { v: 24, f: '12am' }
      ]
    },
    vAxis: {
      minValue: 0
    }
  }

  return (
    <AnalyticsChart
      title={today ? 'Restring Due Time Today' : 'Due Times'}
      chartId={CHART_ID}
      chartType="ColumnChart"
      parseData={parseData}
      options={options}
      event={event}
      filters={{
        dueDate: today ? DateTime.now().startOf('day').toJSDate() : undefined,
        stringer
      }}
    />
  )
}

DueTimesChart.propTypes = propTypes

export default DueTimesChart
